var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowBanner)?_c('div',{staticClass:"banner"},[_c('div',{staticClass:"container"},[_c('v-flex',[_c('AnuncioBanner')],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }